import './App.css';
import NavbarComp from './components/navbarComp';
import Home from "./components/home";
import About from "./components/about";
import Contact from "./components/contact";
import Attractions from "./components/attractions";
import Gallery from "./components/gallery";
import Footer from './components/footer';


function App() {
  return (
    <div className="App">
      <NavbarComp/>
      <section id="home"><Home/></section>
      <section id="o-nas"><About/></section>
      <section id="galeria"><Gallery/></section>
      <section id="kontakt"><Contact/></section>
      <section id="attractions"><Attractions/></section>
      <Footer/>
    </div>
  );
}

export default App;
